var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"side-menu-button"},[_c('round-button',{attrs:{"title":"Change"},nativeOn:{"click":function($event){return _vm.toggleSideMenu($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }